module.exports = __webpack_public_path__ + "static/media/checked.30976fd0.svg";